import {RangeOptionNameType} from "../../types/RangeOptionNameType";

export enum WorthinessSelectsType {
    PROPERTY_TYPE = "propertyType",
    APPLICANTS = "applicants"
}

export enum CreditGtmActionsType {
    CALL = "call"
}

export enum CreditRatingGtmActionsType {
    CALL = "call",
    PROPERTY_TYPE = "propertyType",
    APPLICANTS = "applicants"
}

export type AllCreditGtmActionTypes = RangeOptionNameType | WorthinessSelectsType | CreditGtmActionsType | CreditRatingGtmActionsType;
import {RangeOptionNameType} from "../../types/RangeOptionNameType";

export enum WorthinessSelectsType {
    PROPERTY_TYPE = "propertyType",
    APPLICANTS = "applicants"
}

export enum CreditGtmActionsType {
    CALL = "call"
}

export enum CreditRatingGtmActionsType {
    CALL = "call",
    PROPERTY_TYPE = "propertyType",
    APPLICANTS = "applicants"
}

export type AllCreditGtmActionTypes = RangeOptionNameType | WorthinessSelectsType | CreditGtmActionsType | CreditRatingGtmActionsType;
